'use strict';

var Domain_v1alpha1_schema = require('../schema/kinds/Domain.v1alpha1.schema.json.cjs.js');
var util = require('./util.cjs.js');

const domainEntityV1alpha1Validator = util.ajvCompiledJsonSchemaValidator(Domain_v1alpha1_schema.default);

exports.domainEntityV1alpha1Validator = domainEntityV1alpha1Validator;
//# sourceMappingURL=DomainEntityV1alpha1.cjs.js.map
